import { ProjectCompletionsParmetersCompletionDesignBase } from './base/project-completions-parmeters-completion-design-base';

export class ProjectCompletionsParmetersCompletionDesign extends ProjectCompletionsParmetersCompletionDesignBase { }